import React, { FC, Fragment, PropsWithChildren } from 'react';

import { SidePanelTitle } from '../../components/side-bar/components/design-system';

export const HistoryPanel: FC<PropsWithChildren> = props => {
  const { children } = props;
  return (
    <Fragment>
      <SidePanelTitle>Update History</SidePanelTitle>
      {children}
    </Fragment>
  );
};
